import React, { useState } from 'react';
import { ShoppingCartIcon, XIcon, TrashIcon, CreditCardIcon } from 'lucide-react';
import { useBillingCart } from '../../context/BillingCartContext';
import { PaymentFlowModal } from './PaymentFlowModal';
export function FloatingCart() {
  const {
    items,
    removeItem,
    clearCart,
    total,
    itemCount
  } = useBillingCart();
  const [isExpanded, setIsExpanded] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const handleClearCart = () => {
    clearCart();
    setIsExpanded(false);
  };
  const handleProceedToPay = () => {
    setIsExpanded(false);
    setShowPaymentModal(true);
  };
  const handlePaymentSuccess = () => {
    clearCart();
    setShowPaymentModal(false);
  };
  // Don't render anything if cart is empty
  if (itemCount === 0) return null;
  return <>
      <div className="fixed bottom-6 right-6 z-50" data-id="element-152">
        {/* Expanded Cart Panel */}
        {isExpanded && <div className="absolute bottom-16 right-0 w-80 bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden animate-in slide-in-from-bottom-4 duration-200" data-id="element-153">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-3 flex items-center justify-between" data-id="element-154">
              <h3 className="text-white font-semibold text-sm" data-id="element-155">Your Cart</h3>
              <button onClick={() => setIsExpanded(false)} className="text-white/80 hover:text-white" data-id="element-156">
                <XIcon size={18} data-id="element-157" />
              </button>
            </div>

            <div className="max-h-64 overflow-y-auto" data-id="element-158">
              {items.map(item => <div key={item.id} className="px-4 py-3 border-b border-gray-100 last:border-0" data-id="element-159">
                  <div className="flex justify-between items-start" data-id="element-160">
                    <div className="flex-1" data-id="element-161">
                      <p className="text-sm font-medium text-gray-900" data-id="element-162">
                        {item.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-163">
                        {item.description}
                      </p>
                      {item.details && <p className="text-xs text-blue-600 mt-0.5" data-id="element-164">
                          {item.details}
                        </p>}
                    </div>
                    <div className="flex items-center gap-2 ml-2" data-id="element-165">
                      <span className="text-sm font-semibold text-gray-900" data-id="element-166">
                        ₹{item.price.toLocaleString()}
                      </span>
                      <button onClick={() => removeItem(item.id)} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-167">
                        <TrashIcon size={14} data-id="element-168" />
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>

            <div className="px-4 py-3 bg-gray-50 border-t border-gray-200" data-id="element-169">
              <div className="flex justify-between items-center mb-3" data-id="element-170">
                <span className="text-sm text-gray-600" data-id="element-171">Total</span>
                <span className="text-lg font-bold text-gray-900" data-id="element-172">
                  ₹{total.toLocaleString()}
                </span>
              </div>
              <button onClick={handleProceedToPay} className="w-full py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-semibold text-sm hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center justify-center gap-2" data-id="element-173">
                <CreditCardIcon size={16} data-id="element-174" />
                Proceed to Pay
              </button>
              <button onClick={handleClearCart} className="w-full mt-2 py-2 text-gray-500 text-xs hover:text-red-500 transition-colors" data-id="element-175">
                Clear Cart
              </button>
            </div>
          </div>}

        {/* Floating Button */}
        <button onClick={() => setIsExpanded(!isExpanded)} className="relative w-14 h-14 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center text-white hover:scale-105 active:scale-95" data-id="element-176">
          <ShoppingCartIcon size={24} data-id="element-177" />
          <span className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full text-xs font-bold flex items-center justify-center animate-pulse" data-id="element-178">
            {itemCount}
          </span>
        </button>
      </div>

      {/* Payment Flow Modal */}
      <PaymentFlowModal isOpen={showPaymentModal} onClose={() => setShowPaymentModal(false)} items={items} total={total} onPaymentSuccess={handlePaymentSuccess} data-id="element-179" />
    </>;
}